import { Navigate, useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { useFixedAsset } from '@/hooks/api/2040_fixed_asset';
import { useCurrentFixedAsset } from '@/providers/FixedAssetProvider';
import { toastError } from '@/lib/toast';

type Props = { children?: React.ReactNode };

export const RequireFixedAsset = (props: Props) => {
  const { identifier, fixed_asset_id } = useParams();
  const { data, status } = useFixedAsset({
    identifier: identifier!,
    id: Number(fixed_asset_id!),
  });
  const { fixedAsset, setFixedAsset, fixedAssetDetails, setFixedAssetDetails } = useCurrentFixedAsset();

  useEffect(() => {
    if (data) {
      setFixedAsset((_) => data.fixed_asset);
      setFixedAssetDetails((_) => data.fixed_asset_details);
    }
  }, [data]);

  if (status == 'error') {
    toastError('アクセス出来ませんでした。');
    return <Navigate replace to={`/w/${identifier}`} />;
  }

  if (fixedAsset) {
    return <>{props.children}</>;
  }

  return <></>;
};
